import BaseRepository from "core/repository/base.repository";
import { DiscountService } from "core/service";
import { Discount } from "core/entity";

class DiscountRepository extends BaseRepository {
  syncable = false;

  resourceName() {
    return "descontos";
  }

  getEntityIdentifier() {
    return "discount";
  }

  getServiceProvider() {
    return DiscountService;
  }

  async modelToEntity(model) {
    return new Discount(model);
  }

  async fetch(companyUuid, { filters = [], order = [], pagination = {} }) {
    const serviceResult = await this.mService.fetch(companyUuid, {
      filters,
      order,
      pagination
    });

    if (serviceResult.success) {
      return {
        success: true,
        results: serviceResult.data,
        total: serviceResult.headers["total"],
        perPage: serviceResult.headers["per-page"]
      };
    }

    return {
      success: false,
      fatal: serviceResult.fatal,
      errors: serviceResult.errors
    };
  }

  async create(uuid, params) {
    return await this.mService.create(uuid, params);
  }

  async updateDiscount(uuid, params) {
    return await this.mService.updateDiscount(uuid, params);
  }
}

export default new DiscountRepository();



// WEBPACK FOOTER //
// ./src/core/repository/discount.repository.js